export enum MenuLimitation {
  DataRestrictionsReason = 'DataRestrictionsReason',
  DataRestrictionsExample = 'DataRestrictionsExample',
  CommitmentTransparency = 'CommitmentTransparency',
}

export const LIST_MENU_SIDEBAR_LIMITATION = [
  {
    id: MenuLimitation.DataRestrictionsReason,
    label: 'Why Are There Data Restrictions?',
  },
  {
    id: MenuLimitation.DataRestrictionsExample,
    label: 'Examples of Data Restrictions',
  },
  {
    id: MenuLimitation.CommitmentTransparency,
    label: 'Our Commitment to Transparency',
  },
];
